import PropTypes from "prop-types";
import { ReactNode, forwardRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// material-ui
import { useTheme } from "@mui/material/styles";
import {
  Avatar,
  Chip,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useMediaQuery,
} from "@mui/material";

import { MENU_OPEN, SET_MENU } from "../../store/actions";

// ==============================|| SIDEBAR MENU LIST ITEMS ||============================== //

const NavItem = ({ item, level }: any) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const customization = useSelector((state: any) => state.customization);
  const matchesSM = useMediaQuery(theme.breakpoints.down("lg"));

  const isActive = item?.url == pathname
  const Icon = isActive && item?.activeIco ? item.activeIco : item.icon;
  const itemIcon: ReactNode = isActive && item?.activeIco ? (
    <div className=" rounded-xl mr-2" >

      {Icon}

    </div>

  ) : item?.icon ? (
    <div>

      {Icon}
    </div>
  ) : (
    <img
      className=""
      src={`/assets/icons/${customization.isOpen.findIndex((id: any) => id === item?.id) > -1 ? 'fible-manual-active.svg' : 'fible-manual-icon.svg'}`}
      alt="search"

      width={customization.isOpen.findIndex((id: any) => id === item?.id) > -1
        ? 8
        : 6}
      height={customization.isOpen.findIndex((id: any) => id === item?.id) > -1
        ? 8
        : 6}
    />
  );

  let itemTarget = "_self";
  if (item.target) {
    itemTarget = "_blank";
  }

  let listItemProps: any = {
    /* ts-ignore */
    component: forwardRef((props, ref: any) => (
      <Link ref={ref} {...props} to={item.url} target={itemTarget} />
    )),
  };
  if (item?.external) {
    listItemProps = { component: "a", href: item.url, target: itemTarget };
  }

  const itemHandler = (id: any) => {
    dispatch({ type: MENU_OPEN, id });
    if (matchesSM) dispatch({ type: SET_MENU, opened: false });
  };
  // active menu item on page load
  useEffect(() => {
    const pathParts = document.location.pathname.toString().split("/");
    const lastIndex = pathParts.lastIndexOf(item.id);
    if (lastIndex > -1) {
      dispatch({ type: MENU_OPEN, id: item.id });
    }

    // eslint-disable-next-line
  }, [pathname]);

  return (
    <ListItemButton
      {...listItemProps}
      disabled={item.disabled}
      sx={{
        borderRadius: `12px`,
        mb: 0.5,
        alignItems: "flex-start",
        backgroundColor: level > 1 ? "transparent !important" : "inherit",
        py: level > 1 ? 1 : 1.25,
        pl: `${level * 24}px`,
      }}
      selected={
        customization.isOpen.findIndex((id: any) => id === item.id) > -1
      }
      onClick={() => itemHandler(item.id)}
    >
      <ListItemIcon sx={{ my: "auto", minWidth: !item?.icon ? 18 : 36 }}>
        {itemIcon}
      </ListItemIcon>
      <ListItemText
        primary={
          <Typography
            variant={
              customization.isOpen.findIndex((id: any) => id === item.id) > -1
                ? "body2"
                : "body1"
            }
            color="inherit"
          >
            {item.title}
          </Typography>
        }
        secondary={
          item.caption && (
            <Typography variant="caption" display="block" gutterBottom>
              {item.caption}
            </Typography>
          )
        }
      />
      {item.chip && (
        <Chip
          color={item.chip.color}
          variant={item.chip.variant}
          size={item.chip.size}
          label={item.chip.label}
          avatar={item.chip.avatar && <Avatar>{item.chip.avatar}</Avatar>}
        />
      )}
    </ListItemButton>
  );
};

NavItem.propTypes = {
  item: PropTypes.object,
  level: PropTypes.number,
};

export default NavItem;
